export const validTiersValue = ['basic', 'basic-plus', 'bronze', 'bronze-plus', 'silver', 'silver-plus', 'gold'] as const;
export type TiersType = (typeof validTiersValue)[number];

export default validTiersValue;
